import React from "react";

function GlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
    gotoPage,
    inputClassName = "",
}) {
    const count = preGlobalFilteredRows.length;
    const [value, setValue] = React.useState(globalFilter ?? "");
    const [isFocused, setIsFocused] = React.useState(false);
    const shouldShowHint = isFocused || value.trim() !== "";

    React.useEffect(() => {
        setValue(globalFilter ?? "");
    }, [globalFilter]);

    const applyFilter = React.useCallback(() => {
        const nextValue = value;
        setGlobalFilter(nextValue === "" ? undefined : nextValue);

        if (typeof gotoPage === "function") {
            gotoPage(0);
        }
    }, [gotoPage, setGlobalFilter, value]);

    return (
        <div className="flex flex-col">
            <label className="flex items-baseline gap-x-2">
                <span className="text-gray-700">Search: </span>
                <input
                    type="text"
                    className={inputClassName}
                    value={value}
                    onChange={(e) => {
                        setValue(e.target.value);
                    }}
                    onFocus={() => {
                        setIsFocused(true);
                    }}
                    onBlur={() => {
                        setIsFocused(false);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            applyFilter();
                        }
                    }}
                    placeholder={`${count} records...`}
                />
            </label>
            {shouldShowHint ? (
                <span className="mt-1 text-xs text-gray-500">
                    Press Enter to search
                </span>
            ) : null}
        </div>
    );
}

export default GlobalFilter;
